export default __webpack_public_path__ + "static/media/Thug's Fauld of Creeping Death.49f59294.jpg";